module.exports = __webpack_public_path__ + "img/dinoc-title.72824703.png";